export const sectors = {
    PHARMA: 'pharma',
    BANKANDINSURANCE: 'bank',
    RETAIL: 'retail',
    INDUSTRY: "industry",
    SERVICE: "service",
    REALESTATE: "realestate",
    ENERGY: "energy"
}